import html2canvas from 'html2canvas-pro';
import { jsPDF } from 'jspdf';

export const getMailPdfFileName = (
  subject: string,
  timeCreated: string,
): string => {
  const created = new Date(timeCreated);
  const pad = (value: number) => String(value).padStart(2, '0');
  const date = `${created.getFullYear()}-${pad(created.getMonth() + 1)}-${pad(created.getDate())}`;
  const time = `${pad(created.getHours())}${pad(created.getMinutes())}`;
  const safeSubject = subject.replace(/[\\/:*?"<>|]/g, '').trim();

  return `mail_${safeSubject}_${date}_${time}.pdf`;
};

export const exportElementToPdf = async (
  element: HTMLElement,
  fileName: string,
): Promise<void> => {
  const canvas = await html2canvas(element, {
    scale: 2,
    backgroundColor: '#ffffff',
    useCORS: true,
  });

  const pdf = new jsPDF({ unit: 'px', format: 'a4', orientation: 'portrait' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  const imgData = canvas.toDataURL('image/png');

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position -= pageHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(fileName);
};
